module.exports = __webpack_public_path__ + "static/weAssist-b3da2e72780ff8259320d237723617d2.png";